import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

// 대상 웰라움 순창 Firebase 프로젝트 설정
const firebaseConfig = {
  apiKey: "AIzaSyDG7qdbefU4Zobnk5c7DlDUu5OuFU5sHNY",
  authDomain: "wellaum-5e5e6.firebaseapp.com",
  projectId: "wellaum-5e5e6",
  storageBucket: "wellaum-5e5e6.firebasestorage.app",
  messagingSenderId: "721303462140",
  appId: "1:721303462140:web:44889ddfd11ae00274f779",
  measurementId: "G-DH56DH4ND8"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
